<ng-container *ngIf="_location else noLocation">
    <div class="energy-label-report">
        <div class="energy-label-hero">
            <div class="energy-label-current notranslate" [ngClass]="getCurrentEnergyLabelClass()">
                {{currentEnergyLabel || 'n/a'}}
            </div>
            <dl class="energy-label-registration mb-0">
                <div>
                    <dt>Registration date</dt>
                    <dd class="notranslate">{{_location.refdata?.energyLabelValidity?.start ? formatDate(_location.refdata.energyLabelValidity.start) : 'n/a'}}</dd>
                </div>
                <div>
                    <dt>Valid until</dt>
                    <dd class="notranslate">{{_location.refdata?.energyLabelValidity?.end ? formatDate(_location.refdata.energyLabelValidity.end) : 'n/a'}}</dd>
                </div>
            </dl>
        </div>

        <div class="energy-label-scale" aria-hidden="true">
            <div *ngFor="let label of energyLabels" class="energy-label-segment"
                 [ngClass]="getEnergyLabelClass(label)">
                <span class="notranslate">{{label}}</span>
            </div>
        </div>

        <dl class="energy-label-performance mb-0">
            <div class="energy-label-performance-item">
                <dt>Year built</dt>
                <dd class="notranslate">{{_location.refdata?.buildYear || 'n/a'}}</dd>
            </div>
            <div class="energy-label-performance-item">
                <dt>Area</dt>
                <dd class="notranslate">
                    <ng-container *ngIf="energyLabelArea != null; else noArea">{{energyLabelArea | number:'1.0-0'}} m<sup>2</sup></ng-container>
                    <ng-template #noArea>n/a</ng-template>
                </dd>
            </div>
            <div class="energy-label-performance-item">
                <dt>Building type</dt>
                <dd>{{energyLabelBuildingType || 'n/a'}}</dd>
            </div>
        </dl>
    </div>
</ng-container>

<ng-template #noLocation>
    <p class="text-muted mb-0">No location selected</p>
</ng-template>
